import { ContentSaveCogIcon } from './ContentSaveCogIcon';

/**
 * author: Michael Irigoyen
 * id E909F872-44CC-4D23-8AD2-95BFE02A5E2D
 * name content-save-cog
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-cog.svg
 * tags
 * - Settings 
 */
export const FloppyDiscCogIcon = ContentSaveCogIcon;
export default FloppyDiscCogIcon